import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-sec2-as2',
  templateUrl: './sec2-as2.component.html',
  styleUrls: ['./sec2-as2.component.css']
})
export class Sec2As2Component implements OnInit {
  username = '';
  msg = '';
  disableButton = true;
  color = 'black';
  accounts= [];
  changeCheck = '';
  constructor() { }

  ngOnInit(): void {
  }

  getColor(){
    return this.color;
  }

  clearUsername(){
    this.msg = 'The username "' + this.username + '" was created.'
    this.changeCheck = this.msg;
    this.accounts.push(this.username);
    this.username = ''
    this.disableButton = true;
    this.color = "green";
    setTimeout(() => {
      if (this.msg === this.changeCheck){
        this.msg = '';
      }
    },2000)
  }
  checkUsername(){
    if(this.username === ''){
      this.msg = '';
      this.disableButton = true;
    } else if(this.username.length < 5){
      this.msg = 'Username "' + this.username + '" must be at least 5 characters.';
      this.disableButton = true;
      this.color = "red";
    } else if(this.username.startsWith(" ")|| this.username.endsWith(" ")){
      this.disableButton = true;
      this.msg = 'Username "' + this.username + '" must not start or end with whitespace';
      this.color = "red";
    } else if(this.accounts.includes(this.username)){
      this.msg = 'Username "' + this.username + '" is taken.';
      this.disableButton = true;
      this.color = "red";
    } else {
      this.msg = 'Username "' + this.username + '" is available.';
      this.disableButton = false;
      this.color = "green"
    }
  }
}
